import {
  colors,
  Field,
  gap,
  gutter,
  media,
  NewTypography,
  NewTypography as Typography,
  opacity,
  RoundButton as RoundButtonParent,
  spacing,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

interface ContainerProps {
  positionX?: 'start' | 'center' | 'end';
  positionY?: 'start' | 'center' | 'end';
  loading?: boolean;
}

interface FieldRowProps {
  columnsTemplate?: string;
  error?: boolean;
  marginBottom?: keyof typeof spacing | 'errorDefault' | 'errorLarge';
}

const errorMarginBottom = {
  errorDefault: '3rem',
  errorLarge: '4rem',
};

const fieldMargin = Object.assign(spacing, errorMarginBottom);

export const Container = styled.div<ContainerProps>`
  ${({ positionX = 'start', positionY = 'start' }) => css`
    min-height: 100%;
    width: 100%;
    display: flex;
    align-items: ${positionX};
    justify-content: ${positionY};
    flex-direction: column;

    ${gap(spacing.medium)};
  `};
`;

export const GlobalArea = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${gap(spacing.medium)};

  ${media.greaterThan('tablet')`
    flex-direction: column;
  `};
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  ${gap(spacing.small)};
`;

export const ButtonContent = styled(Typography)`
  font-size: 1.4rem;
`;

export const SmallTypography = styled(Typography)`
  font-size: 1.2rem;
`;

export const RoundButton = styled(RoundButtonParent)`
  && {
    min-width: initial;
    height: initial;
    padding: 0.6rem ${spacing.medium};
  }
`;

export const FileListItem = styled.li`
  & + li {
    margin-top: ${spacing.small};
  }
`;

export const FileList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${gap(spacing.medium)};
`;

export const ContentWrapper = styled.div<{ desktopColumns?: string }>`
  ${({ desktopColumns = '1fr fr' }) => css`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-content: center;

    ${media.greaterThan('tablet')`
      grid-template-columns: ${desktopColumns};
    `}

    ${gap(spacing.small)};
  `}
`;

export const ProfessionalRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${gap(spacing.small)};
`;

export const Input = styled(Field)`
  padding: ${spacing.small} calc(0.75rem + ${gutter.default});

  svg {
    fill: ${colors.dark};
  }
`;

export const OpacityTypography = styled(NewTypography)`
  opacity: ${opacity.hard};
`;

export const FieldRow = styled.div<FieldRowProps>`
  ${({ columnsTemplate = '1fr', marginBottom = 'medium' }) => css`
    display: grid;
    gap: ${spacing.medium};
    grid-template-columns: ${columnsTemplate};
    align-items: end;
    margin-bottom: ${fieldMargin[marginBottom]};

    p {
      position: absolute;
      top: calc(100% + 5px);
    }

    svg {
      fill: ${colors.dark};
    }
  `};
`;

export const SelectFieldContainer = styled.div`
  p {
    top: unset;
    margin-top: 5px;
  }
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;

  svg {
    fill: ${colors.dark};
  }
`;

export const Form = styled.form<{ loading?: boolean }>`
  ${({ loading = false }) => css`
    min-height: 100%;

    ${loading &&
    css`
      height: 100%;
    `};
  `}
`;
